import { groupPermissionAdminApi } from '@/api/admin/group-permission';
import type { RootState } from '@/store';
import type { IThunkAPI } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type {
  IGroupPermission,
  IGroupPermissionDelete,
  IGroupPermissionPost,
  IGroupPermissionRequest,
  IGroupPermissionState,
} from '../types/types';

const initialState: IGroupPermissionState = {
  groupPermissionList: [],
};

export const getGroupPermissionList = createAsyncThunk<Array<IGroupPermission>, IGroupPermissionRequest, IThunkAPI>(
  'get/group/permission/client/clientId/group/groupId/list',
  async ({ clientId, groupId }, thunkAPI) => {
    try {
      const response = await groupPermissionAdminApi.getGroupPermission(clientId, groupId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const saveGroupPermission = createAsyncThunk<unknown, IGroupPermissionPost, IThunkAPI>(
  'post/admin/group/permission/create',
  async (groupPermission, thunkAPI) => {
    try {
      const response = await groupPermissionAdminApi.saveGroupPermission(groupPermission);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const deleteGroupPermission = createAsyncThunk<unknown, IGroupPermissionDelete, IThunkAPI>(
  'post/admin/group/permission/delete',
  async (groupPermission, thunkAPI) => {
    try {
      const response = await groupPermissionAdminApi.deleteGroupPermission(groupPermission);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const groupPermissionAdminSlice = createSlice({
  name: 'groupPermissionAdmin',
  initialState,
  reducers: {
    clearGroupPermissionList(state) {
      state.groupPermissionList = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(getGroupPermissionList.fulfilled, (state, action) => {
      state.groupPermissionList = action.payload;
    });
  },
});

// actions
export const { clearGroupPermissionList } = groupPermissionAdminSlice.actions;

// selectors
export const groupPermissionList = (state: RootState): IGroupPermissionState['groupPermissionList'] =>
  state.groupPermissionAdmin.groupPermissionList;

export default groupPermissionAdminSlice.reducer;
